import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { QuestionnaireAPI } from '../../services/api';
import RenderedQuestion from '../pages/Questionnaire/QuestionnerRenders/QuestionRender';
import RefrencesRender from '../pages/Questionnaire/QuestionnerRenders/RefrencesRender';
import { ButtonContainer, Container, StyledButton } from '../pages/Questionnaire/styles';
import { LabeledTimer } from '../LabeledTimer';


export default function QuestionView({ payload, timeLeft, moveToNextQuestion, jumpToQuestionIndex, questionnairePosition, registerAnswerFlush }) {
  const {
    questionText,
    options,
    userAnswer,
    questionIndex,
    questionId,
    references
  } = payload;

  const [currentResponse, setCurrentResponse] = useState(userAnswer);
  const [validationDialogOpen, setValidationDialogOpen] = useState(false);

  // Sync state if server data changes (e.g. navigation)
  useEffect(() => {
    setCurrentResponse(userAnswer);
  }, [userAnswer, questionIndex]);

  const handleResponse = (responseObj) => {
    // responseObj: { questionID, response }
    setCurrentResponse(responseObj.response);
  };

  const validate = () => {
    // Check if this is an open question (weird logic copied from QuestionRender.js):
    const isMultiChoice = options && (options.length > 1 || (options.length === 1 && options[0].text === "אני מתחייב"));
    if (isMultiChoice) return true;

    // Open question validation logic (copied from openQuestion.js):
    const type = options && options[0] ? options[0].text : null;
    const input = currentResponse || "";

    switch (type) {
      case "שאלה פתוחה של קודון":
        // 3 letters (A, M, N, or O)
        const regex = /^[AMNO]{3}$/;
        return regex.test(input.trim().toUpperCase());
      default:
        // No validation needed for other types
        return true;
    }
  }

  const submitCurrentAnswer = async () => {
    if (currentResponse === null || currentResponse === undefined) return true;
    try {
      await QuestionnaireAPI.submit(questionnairePosition, currentResponse);
      return true;
    } catch (e) {
      console.error("Submit failed", e);
      return false;
    }
  };

  // Let the page save this answer before an operator moves the test-taker away, so a
  // move that arrives mid-question doesn't throw away what they had selected.
  useEffect(() => {
    if (!registerAnswerFlush) return;
    registerAnswerFlush(submitCurrentAnswer);
    return () => registerAnswerFlush(null);
  });

  const handleNextClick = async () => {
    if (!validate()) {
      setValidationDialogOpen(true);
      return;
    }
    await submitCurrentAnswer();
    moveToNextQuestion();
  };

  const handlePreviousClick = async () => {
    if (currentResponse && !validate()) {
      setValidationDialogOpen(true);
      return;
    }
    await submitCurrentAnswer();
    jumpToQuestionIndex(questionIndex - 1);
  };

  // Construct currentQuestion object expected by RenderedQuestion
  const currentQuestion = {
    questionIndex,
    questionId,
    questionText,
    options,
  };

  return (
    <>
      {Number.isFinite(timeLeft) && (
        <LabeledTimer
          label="זמן עד סוף הפרק"
          timeSec={timeLeft}
          sx={{
            position: 'absolute',
            top: '24px',
            left: '24px',
            zIndex: 1000,
          }}
        />
      )}

      <div>
        <Container style={{ zIndex: 500 }}>
          <RenderedQuestion
            currentQuestion={currentQuestion}
            currentUserAnswer={currentResponse}
            onResponse={handleResponse}
          />

          <ButtonContainer style={{ marginTop: 'auto' }}>
            <StyledButton
              variant="contained"
              disabled={currentResponse === null || currentResponse === undefined}
              onClick={handleNextClick}
            >
              הבא
            </StyledButton>
            <StyledButton
              variant="contained"
              disabled={questionIndex === 0}
              onClick={handlePreviousClick}
            >
              קודם
            </StyledButton>
          </ButtonContainer>
        </Container>

        <div style={{ marginTop: '24px' }}>
          <RefrencesRender refrences={references} />
        </div>
      </div>

      <Dialog open={validationDialogOpen} onClose={() => setValidationDialogOpen(false)} dir="rtl">
        <DialogTitle style={{ textAlign: 'right', direction: 'rtl' }}>תשובה לא תקינה</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ direction: 'rtl', textAlign: 'right', padding: '8px 0' }}>
            תשובת השאלה אינה תקינה. אנא תקן את תשובתך.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'flex-start' }}>
          <StyledButton onClick={() => setValidationDialogOpen(false)}>
            הבנתי
          </StyledButton>
        </DialogActions>
      </Dialog>
    </>

  );
}
